<template>
  <b-avatar class="mx-0 my-0" rounded="sm" variant="light">
    <img width="20px" style="margin-right: 8px; margin-left: 8px;" :src="sessionIconSrc"/>
  </b-avatar>
</template>

<script>
export default {
  name: "SessionIcon",
  props: ["session"],
  data() {
    return {
    }
  },
  computed: {

    sessionIconSrc: function() {

      let path = 'icon_test_free.png';
      if(this.session && this.session.protocolType) {
        let type = this.session.protocolType;
        if(type == 'stepTest') {
          path = 'icon_test_step.png';
        } else if(type == 'intervalTest') {
          path = 'icon_test_interval.png';
        } else if(type == 'fiveOneFiveTest') {
          path = 'icon_test_515.png';
        } else if(type == 'restingTest') {
          path = 'icon_test_resting.png';
        }
      }

      return require('../../assets/' + path);
    },

  }
}
</script>

<style scoped>

</style>